export default "<app-preventivi-list></app-preventivi-list>";